<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/kUgSwk/images/Cover.jpg?1701518089771" alt="This image is the cover for the book Space Between, The #1, Space Between, The"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Space Between, The #1, Space Between, The
      </h1>
      <p class="bookDescription body article font2">
        <p>Aboard the interstellar ark known as the Dodona, the populations of workers live in strictly separated social castes during the journey that will take multiple generations to complete. But everything changes when a pilot from the upper tier named Revla falls to the lower levels and meets Les, and they must risk everything for not just themselves, but all aboard the Dodona! Each issue in the limited series features a new pair of protagonists and a new generation of humanity in a sci-fi epic of love, survival, and liberation from Hugo and Eisner Award-nominated and New York Times bestselling writer Corinna Bechko (The Expanse, Green Lantern: Earth One) and acclaimed comics artist Danny Luckert (Ghostlore, The Red Mother).</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Corinna Bechko, Danny Luckert
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      BOOM! Studios
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4741f5b6